import * as React from 'react';
import Icon from '../../../../icons/Icon';

export default class HouseIcon extends Icon {
    renderIcon() {
        return (
            <svg width={this.getSize()} height={this.getSize()} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0" y="0" viewBox="0 0 514 514">
                <circle cx="257" cy="257" r="257" fill="#FFFFFF"></circle>
                <g>
                    <defs>
                        <circle id="SVGID_1_" cx="257" cy="257" r="257"></circle>
                    </defs>
                    <clipPath id="SVGID_00000164511261990292026230000015937538953300109223_">
                        <use overflow="visible" xlinkHref="#SVGID_1_"></use>
                    </clipPath>
                    <g clipPath="url(#SVGID_00000164511261990292026230000015937538953300109223_)">
                        <g fill="#4D5E80">
                            <path d="M360.349 372.092c-15.881 0-24.45-28.23-24.45-54.791 0-26.568 8.568-54.8 24.45-54.8 15.88 0 24.451 28.231 24.451 54.8-.001 26.56-8.572 54.791-24.451 54.791zm0-100.844c-6.556 0-15.701 17.522-15.701 46.053 0 28.527 9.145 46.043 15.701 46.043 6.558 0 15.703-17.516 15.703-46.043 0-28.531-9.145-46.053-15.703-46.053z"></path>
                            <path d="M360.349 413.101a4.376 4.376 0 01-4.375-4.375v-91.425a4.377 4.377 0 014.375-4.375 4.376 4.376 0 014.374 4.375v91.425a4.376 4.376 0 01-4.374 4.375z"></path>
                        </g>
                        <path
                            fill="#4D5E80"
                            d="M463.626 413.101H318.717a4.374 4.374 0 01-4.373-4.375V288.54l-19.035-14.239a4.371 4.371 0 01-1.754-3.502v-50.205h-21.624v27.485a4.377 4.377 0 01-2.414 3.911 4.381 4.381 0 01-4.579-.409l-39.874-29.826-82.966 66.691v120.279a4.376 4.376 0 01-4.373 4.375H50.374a4.375 4.375 0 010-8.748h82.977v-118c0-1.324.602-2.58 1.635-3.408l87.243-70.13a4.369 4.369 0 015.359-.095l35.597 26.625v-23.123a4.372 4.372 0 014.374-4.373h30.371a4.373 4.373 0 014.374 4.373v52.387l19.036 14.241a4.374 4.374 0 011.753 3.503v118.001h140.534a4.376 4.376 0 014.374 4.373 4.377 4.377 0 01-4.375 4.375z"
                        ></path>
                    </g>
                </g>
            </svg>
        );
    }
}